import React, { useState } from "react";
import ReactDOM from "react-dom";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";

const CascadeTree = () => {
  const [planModal, setPlanModal] = useState(false);
  const data = {
    id: "A0",
    level: "group",
    value: {
      title: "Group",
      items: [
        {
          text: "Target",
          value: "10 Million",
        },
        {
          text: "Reached",
          value: "5 Million",
        },
      ],
    },
    children: [
      {
        id: "A1",
        level: "company",
        value: {
          title: "Company 1",
          items: [
            {
              text: "Target",
              value: "5 Million",
            },
            {
              text: "Reached",
              value: "2 Million",
            },
          ],
        },
        children: [
          {
            id: "A11",
            level: "department",
            value: {
              title: "Dep 1",
              items: [
                {
                  text: "Target",
                  value: "2 Million",
                },
                {
                  text: "Reached",
                  value: "1 Million",
                },
              ],
            },
            children: [
              {
                id: "A111",
                level: "division",
                value: {
                  title: "Div 1",
                  items: [
                    {
                      text: "Target",
                      value: "1 Million",
                    },
                    {
                      text: "Reached",
                      value: "0.5 Million",
                    },
                  ],
                },
              },
              {
                id: "A112",
                level: "division",
                value: {
                  title: "Div 2",
                  items: [
                    {
                      text: "Target",
                      value: "1 Million",
                    },
                    {
                      text: "Reached",
                      value: "0.5 Million",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A12",
            level: "department",
            value: {
              title: "Dep 2",
              items: [
                {
                  text: "Target",
                  value: "1 Million",
                },
                {
                  text: "Reached",
                  value: "0.5 Million",
                },
              ],
            },
          },
          {
            id: "A13",
            level: "company",
            value: {
              title: "Company 1",
              items: [
                {
                  text: "Target",
                  value: "2 Million",
                },
                {
                  text: "Reached",
                  value: "0.5 Million",
                },
              ],
            },
          },
        ],
      },
      {
        id: "A2",
        level: "company",
        value: {
          title: "Company 2",
          items: [
            {
              text: "Target",
              value: "5 Million",
            },
            {
              text: "Reached",
              value: "3 Million",
            },
          ],
        },
        children: [
          {
            id: "A21",
            level: "department",
            value: {
              title: "Dep 1",
              items: [
                {
                  text: "Target",
                  value: "2 Million",
                },
                {
                  text: "Reached",
                  value: "1 Million",
                },
              ],
            },
            children: [
              {
                id: "A211",
                level: "division",
                value: {
                  title: "Div 1",
                  items: [
                    {
                      text: "Target",
                      value: "1 Million",
                    },
                    {
                      text: "Reached",
                      value: "0.5 Million",
                    },
                  ],
                },
              },
              {
                id: "A212",
                level: "division",
                value: {
                  title: "Div 2",
                  items: [
                    {
                      text: "Target",
                      value: "1 Million",
                    },
                    {
                      text: "Reached",
                      value: "0.5 Million",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A22",
            level: "department",
            value: {
              title: "Dep 2",
              items: [
                {
                  text: "Target",
                  value: "3 Million",
                },
                {
                  text: "Reached",
                  value: "2 Million",
                },
              ],
            },
          },
        ],
      },
    ],
  };

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    if (node.level === "group") {
      nodeColor = "rgb(63, 81, 181)";
    } else if (node.level === "company") {
      nodeColor = "rgb(244, 67, 54)";
    } else if (node.level === "department") {
      nodeColor = "rgb(76, 175, 80)";
    } else if (node.level === "division") {
      nodeColor = "rgb(255, 193, 7)";
    }
    return nodeColor;
  }

  const config = {
    data,
    // markerCfg: (cfg) => {
    //   const { children } = cfg;
    //   return {
    //     show: children?.length,
    //   };
    // },
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
  };

  return (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setPlanModal(true);
            });
          }}
        />
      </div>
      <PlanInfoModal
        visible={planModal}
        handleCancel={() => setPlanModal(false)}
      />
    </>
  );
};

export default CascadeTree;
